import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkorderService } from 'src/app/core/services/facility/maintenance/workorder/workorder.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule , DatePipe} from '@angular/common';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
@Component({
  selector: 'app-wo-print-page',
  standalone: true,
  imports: [CommonModule, TranslateModule, DatePipe, ButtonComponent, LoadingComponent],
  templateUrl: './wo-print-page.component.html',
  styleUrl: './wo-print-page.component.scss',
  host: { class: 'wo-print-page-host' },
})
export class WOPrintPageComponent {
  BtnPrint = false;
  readonly isElSalamUrl = window.location.href.toLowerCase().includes('elsalam');
  workorder: any;
  status:any;
  loading: boolean = false;
  companyLink = localStorage.getItem('companyLink');
  companyCode = localStorage.getItem('companyCode');
  CompanyLogo = (this.companyLink ?? '') + '\\FilesServer\\logos'+ '/' + (this.companyCode ?? '') + '.png';


  constructor(private readonly activedroute: ActivatedRoute , private readonly workorderService : WorkorderService) {
    const id = this.activedroute.snapshot.paramMap.get('id');
    this.getServiceRequestDetails(Number(id));
    console.log(this.CompanyLogo)
  }

  get sparePartsList(): any[] {
    return Array.isArray(this.workorder?.spareParts) ? this.workorder.spareParts : [];
  }

  getServiceRequestDetails(id : number) {
    this.loading = true;
    this.workorderService
      .getWorkorderProfileById(id)
      .subscribe({
        next: (res) => {
          if (res.isSuccess) {
              this.workorder = (res?.data);
              this.status = this.workorder.workFlowSteps.find((x: { isActive: any; }) => x.isActive)?.name;
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  async SavePDf() {
    this.BtnPrint = true;
    await new Promise<void>((resolve) => {
      setTimeout(() => {
        globalThis.print();
        this.BtnPrint = false;
        resolve();
      }, 1000);
    });
  }

  getCompanyLogo() {
      let companyLink = localStorage.getItem('companyLink');
      let companyCode = localStorage.getItem('companyCode');

      this.CompanyLogo = (companyLink ?? '') + (companyCode ?? '') + '.png';
  }
}
